import React from "react";
import css from "./FieldBody.module.css";
import SectionView from "../../SectionView";
import {NoticeView,TextView} from "Components";
import {book0} from "Assets";


export default function FieldBody(props){
    const {field}=props,{description,notice,tip}=field;
    const subfields=field.props||field.overloads;
    return (
        <div className={css.fieldbody}>
            {description&&<TextView className={css.description} text={description}/>}
            {subfields&&
                <SectionView 
                    className={css.subfields}
                    title={field.overloads&&"overloads"}
                    fields={subfields}
                />
            }
            {field.component&&<div className={css.component}><field.component field={field}/></div>}
            {(notice||tip)&&<NoticeView 
                className={css.noticeview}
                text={tip||notice} icon={tip&&book0}
            />}
            {/* {description&&
                <div className={css.bordertop}/>
            } */}
        </div>
    )
}
